const initialValue = {
  previousStep: 0,
  flow: "",
  debtInfo: {
    id: "",
    company: {
      name: "",
      cnpj: "",
      addressStreet: "",
      addressNumber: "",
      addressNeighborhood: "",
      addressCity: "",
      addressUF: "",
      addressCountry: "",
      addressZipCode: "",
    },
    partner: {
      name: "",
      cpf: "",
      email: "",
      addressStreet: "",
      addressNumber: "",
      addressNeighborhood: "",
      addressCity: "",
      addressUF: "",
      addressCountry: "",
      addressZipCode: "",
      nationality: "",
      civilStatus: "",
      office: "",
      documentRg: "",
      documentRgIssuer: "",
    },
    openingDate: "",
    calculationDate: "",
    naturesDebt: [],
    totalDebt: 0,
    status: "",
    signatureUrl: "",
    partners: [],
    debts: [],
    missingSignatures: 0,
    documentUrl: "",
  },
  payment: {
    paymentType: "",
    total: 0,
    paymentWay: null,
    numberInstallments: null,
    valueInstallments: null,
    proposalId: "",
  },
  currentProposal: 0,
  activeProposals: [],
  archivedProposals: [],
  unpaidProposals: [],
  proposal: {
    negotiationOptions: [],
    counterProposal: null,
    message: "",
    paymentType: "",
    paymentWay: null,
    entry: null,
    numberInstallments: null,
    valueInstallments: null,
  },
  successMessage: {
    title: "",
    description: "",
    type: "",
    hasButton: false,
  },
};

export default function charge(state = initialValue, action) {
  
  switch (action.type) {
    case "CHANGE_PREVIOUS_STEP":
      return { ...state, previousStep: action.payload };
    case "CHANGE_FLOW":
      return { ...state, flow: action.payload };
    case "CHANGE_CURRENT_PROPOSAL":
      return { ...state, currentProposal: action.payload };
    case "CHANGE_PROPOSAL":
      return {
        ...state,
        proposal: { ...state.proposal, ...action.payload },
      };
    case "CHANGE_ACTIVE_PROPOSALS":
      return {
        ...state,
        activeProposals: [...action.payload],
      };
    case "CHANGE_ARCHIVED_PROPOSALS":
      return {
        ...state,
        archivedProposals: [...action.payload],
      };

    case "CHANGE_UNPAID_PROPOSALS":
      return {
        ...state,
        unpaidProposals: [...action.payload],
      };
    case "CHANGE_DEBT_INFO":
      return {
        ...state,
        debtInfo: { ...state.debtInfo, ...action.payload },
      };
    case "CHANGE_PAYMENT":
      return { ...state, payment: { ...state.payment, ...action.payload } };
    case "CHANGE_SUCCESS_MESSAGE":
      return {
        ...state,
        successMessage: { ...state.successMessage, ...action.payload },
      };
    case "RESET_CHARGE_INFO": {
      return initialValue;
    }
    default:
      return state;
  }
}
